/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-update.vue?vue&type=template&id=3158a3f4&scoped=true&"
import script from "./batch-update.vue?vue&type=script&lang=ts&"
export * from "./batch-update.vue?vue&type=script&lang=ts&"
import style0 from "./batch-update.vue?vue&type=style&index=0&id=3158a3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158a3f4",
  null
  
)

export default component.exports